import { commonHandle } from './common';
import { loanMonitorHandle } from './loanMonitor';

export interface ApiErrorResponse {
  code: number;
  msg: string;
  data: any;
  success: boolean;
}

// 合并所有处理器
export const REQUEST_CODE_HANDLE: Record<number, (error: ApiErrorResponse) => void> = {
  ...commonHandle,
  ...loanMonitorHandle,
} as const;

export default REQUEST_CODE_HANDLE;
